import {storage, defaultCookieSettings} from '../../constants/defaultValues'

import {
    SET_COOKIE_SETTINGS
} from '../types'


let loc = window.location.hostname.split('.')
const LOCALE = ['localhost', 'cz'].includes(loc[loc.length - 1]) ? 'cz' : 'sk'

export const locale = (state = LOCALE) => {
    return state
}

const cookie_settings = localStorage.getItem(storage.cookie_settings)
let INIT_COOKIE_SETTINGS = cookie_settings ? JSON.parse(cookie_settings) : defaultCookieSettings
if(Object.keys(INIT_COOKIE_SETTINGS.cookies).length < Object.keys(defaultCookieSettings).length){
    INIT_COOKIE_SETTINGS = defaultCookieSettings
}

export const cookieSettings = (state = INIT_COOKIE_SETTINGS, action) => {
    if (action.type === SET_COOKIE_SETTINGS) {
        const newData = {
            cookies: action.payload,
            is_default: false
        }
        localStorage.setItem(storage.cookie_settings, JSON.stringify(newData))
        return newData
    } else {
        return state
    }
}